module.exports = __webpack_public_path__ + "img/WMD.d6b7b0b8.png";